import OrderList from '@/views/order/order-list.vue';
import OrderDetail from '@/views/order/order-detail.vue';
import OrderReturn from '@/views/order/order-return.vue';

export default [
    {
        path:'/order-list',
        component: OrderList,
        name: 'orderList'
    },
    {
        path:'/order-detail',
        component: OrderDetail,
        name: 'orderDetail'
    },
    {
        path:'/order-return',
        component: OrderReturn,
        name: 'orderReturn'
    }
]